import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function CtaSection({
  title = "土地のこと、まちのこと。",
  highlight = "まずはご相談ください。",
  text = "工事のご依頼・お見積りから不動産のご相談、協力会社・採用のお問い合わせまで、お気軽にどうぞ。",
  button = "お問い合わせ",
  to = "/contact",
}) {
  return (
    <section data-testid="cta-section" className="relative overflow-hidden border-t border-line bg-coal py-[67px] md:py-[90px]">
      <div className="absolute inset-0 bg-blueprint opacity-40" />
      <div className="absolute -right-24 -top-24 h-72 w-72 rotate-45 bg-accent/10" />
      <div className="absolute -bottom-32 -left-16 h-64 w-64 rotate-45 border border-accent/20" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="flex items-center gap-3 font-mono text-xs tracking-[0.35em] text-accent">
            <span className="h-px w-10 bg-accent" />
            CONTACT
          </p>
        </Reveal>
        <Reveal delay={0.06}>
          <h2 className="mt-6 font-mincho text-3xl font-bold leading-tight text-white sm:text-5xl">
            {title}
            <br />
            <span className="text-accent">{highlight}</span>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-gray-400 sm:text-base">{text}</p>
        </Reveal>
        <Reveal delay={0.18}>
          <Link
            data-testid="cta-contact-button"
            to={to}
            className="group mt-10 inline-flex items-center gap-3 bg-accent px-8 py-4 font-display text-base font-bold tracking-[0.15em] text-ink transition-colors hover:bg-accent-hover"
          >
            {button}
            <ArrowUpRight className="h-5 w-5 transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
